/**
 * @generated SignedSource<<8ad60c8b68d1ff3abe4ecaae10f36cc6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EndOfPageRecommendation_recommendedPages$data = {
  readonly recommendedPages: ReadonlyArray<{
    readonly content: {
      readonly creatorId: string | null;
      readonly emoji: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null;
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly history: {
        readonly ownedBy: {
          readonly displayName: string | null;
        } | null;
      } | null;
      readonly id: string | null;
      readonly links: {
        readonly webui: string | null;
      } | null;
      readonly space: {
        readonly id: string | null;
        readonly key: string | null;
        readonly name: string | null;
      } | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly type: string | null;
    } | null;
    readonly strategy: ReadonlyArray<string>;
  }>;
  readonly " $fragmentType": "EndOfPageRecommendation_recommendedPages";
};
export type EndOfPageRecommendation_recommendedPages$key = {
  readonly " $data"?: EndOfPageRecommendation_recommendedPages$data;
  readonly " $fragmentSpreads": FragmentRefs<"EndOfPageRecommendation_recommendedPages">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "key"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "EndOfPageRecommendation_recommendedPages",
  "selections": [
    {
      "concreteType": "RecommendedPagesItem",
      "kind": "LinkedField",
      "name": "recommendedPages",
      "plural": true,
      "selections": [
        {
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "title"
            },
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "kind": "ScalarField",
              "name": "subType"
            },
            {
              "kind": "ScalarField",
              "name": "creatorId"
            },
            {
              "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
              "kind": "LinkedField",
              "name": "links",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "webui"
                }
              ]
            },
            {
              "concreteType": "History",
              "kind": "LinkedField",
              "name": "history",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "ownedBy",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "displayName"
                    }
                  ]
                }
              ]
            },
            {
              "concreteType": "Space",
              "kind": "LinkedField",
              "name": "space",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "name"
                }
              ]
            },
            {
              "alias": "emoji",
              "args": [
                {
                  "kind": "Literal",
                  "name": "key",
                  "value": "emoji-title-published"
                }
              ],
              "concreteType": "PaginatedJsonContentPropertyList",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JsonContentProperty",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "value"
                    }
                  ]
                }
              ],
              "storageKey": "properties(key:\"emoji-title-published\")"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "strategy"
        }
      ]
    }
  ],
  "type": "RecommendedPages"
};
})();

(node as any).hash = "841aea27c92c5de2d816297d86d5ab50";

export default node;
